import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogTitle, Typography } from '@mui/material';
import { CloseDialogButton } from './CloseDialogButton';
export const HolidayDialog = ({ open, closeDialog, title, children, closeDialogButton, }) => {
    return (_jsxs(Dialog, { fullWidth: true, sx: {
            '& .MuiDialog-container': {
                alignItems: 'flex-start',
            },
        }, PaperProps: {
            sx: {
                maxWidth: 'sm',
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px 0px',
            },
        }, open: open, onClose: closeDialog, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [_jsx(DialogTitle, { id: "alert-dialog-title", sx: { paddingBottom: '0px' }, children: _jsx(Typography, { variant: "body1", sx: { lineHeight: '2em' }, children: title }) }), _jsx(CloseDialogButton, { onClose: closeDialogButton }), children] }));
};
